<div *ngIf="params" class="ag-header-cell-label" [ngClass]="{'numeric-column-alignment':  headerAlignement() === true,
'other-column-alignment': headerAlignement() === false}">
	<span [ngClass]="{'numeric-column-text-alignment':  headerAlignement() === true}" class="ag-header-cell-text"
		>{{params.displayName}}</span>
		<div *ngIf="params && params.showCheckbox" class="checkbox-container ag-header-icon e-menu">
			<mat-icon *ngIf="allSelected === 'checked'" [svgIcon]="params.icon_checked" class="copo-datacenter-grid-icon-16"
				(click)="unselect($event)"></mat-icon>
			<mat-icon *ngIf="allSelected === 'unchecked'" [svgIcon]="params.icon_unchecked" class="copo-datacenter-grid-icon-16"
				(click)="select($event)"></mat-icon>
			<mat-icon *ngIf="allSelected === 'indeterminate'" [svgIcon]="params.icon_indeterminate"
				class="copo-datacenter-grid-icon-16" (click)="select($event)"></mat-icon>
		</div>
</div>
